import { RoleIdDto } from '../services/usersapi/usersapi.services';

export class UnassignRolesByUserIdRequest {
  userId: string;
  requestBody: RoleIdDto[];
}
